import * as React from 'react';
import { IEpiProps } from '../../state-helpers/epi-props';
import * as Redux from 'redux';
import { addUrlProps, UrlQueryParamTypes, subquery, multiPushInUrlQuery, pushInUrlQuery } from 'react-url-query';
import { fetchResults } from '../../actions/results';
import { ISearchAppState } from '../../reducers/index';
import { connect } from 'react-redux';

export interface ISuggestionProps {
    suggestion: string;
    epiProps: IEpiProps;
    loading: boolean;

    onSuggestionClick: () => void;
}

//End routing 

export class Suggestion extends React.Component<ISuggestionProps, any> {

    /* XXX: move to connected component
    suggestionClick(e) {
        this.props.dispatch(setSearchTerm(this.props.suggestion));
        this.props.dispatch(setPage(1));
        this.props.dispatch(fetchResults());
        this.props.dispatch(setAutocompleteActive(false));
        multiPushInUrlQuery({ k: this.props.suggestion, page: '1' });
        (document.getElementById('txt_search') as HTMLInputElement).value = this.props.suggestion;

        e.preventDefault();
        e.stopPropagation();
        return false;
    }
    */

    render() {
        if (this.props.suggestion === null || this.props.suggestion.length <= 0 || this.props.loading === true) {
            return null;
        }

        return (
            <p className="paragraph-caption search-bar-subtext search-bar-info-suggestions">
                {this.props.epiProps.suggestionText} <a href="#" className="search-suggestion-link" onClick={this.props.onSuggestionClick}><u>{this.props.suggestion}</u></a>?
            </p>
        );
    }
}
